import React, { useEffect, useState } from 'react'

function WeatherCard({tempInfo}) {
    const [date, setDate] = useState(new Date());
  
  function refreshClock() {
    setDate(new Date());
  }
  useEffect(() => {
    const timerId = setInterval(refreshClock, 1000);
    return function cleanup() {
      clearInterval(timerId);
    };
  }, []);
    const [weatherState,setWeatherState]=useState("");
    const {temp,humidity,pressure,weathermood,name,speed,country,sunset}=tempInfo;
    const newdate=new Date(sunset*1000);
    const time=`${newdate.getHours()}:${newdate.getMinutes()} ${newdate.getHours()>=12?"PM":"AM"}`
    useEffect(()=>{
        if(weathermood){
            switch(weathermood){
                case "Clouds":setWeatherState("wi wi-day-cloudy");
                break;
                case "Haze":setWeatherState("wi day-haze");
                break;
                case "clear":setWeatherState("wi wi-day-sunny");
                break;
                case "Smoke":setWeatherState("wi wi-smoke");
                break;
                default:setWeatherState("wi wi-day-sunny");
                break;
            }
        }
    },[weathermood])
  return (
    <>
        <article className='widget'>
        <div className='weatherIcon'>
            <i className={`${weatherState}`}></i>
        </div>
        <div className='weatherInfo'>
            <div className='temperature'>
                <span>{temp}&deg;</span>
            </div>
            <div className='description'>
                <div className='weatherCondition'>{weathermood}</div>
                <div className='place'>{name},{country}</div>
            </div>
        </div>
        <div className='date'>
            {date.toLocaleString()}
        </div>
        <div className='extra-temp'>
            <div className='temp-info-minmax'>
                <div className='two-sided-section'>
                    <p>
                        <i className={'wi wi-sunset'}></i>
                    </p>
                    <p className='extra-info-leftside'>
                        {time} <br/>
                        sunset
                    </p>
                </div>
                <div className='two-sided-section'>
                    <p>
                        <i className={'wi wi-humidity'}></i>
                    </p>
                    <p className='extra-info-leftside'>
                        {humidity}% <br/>
                        humidity
                    </p>
                </div>
            </div>
            <div className='weather-extra-info'>
            <div className='two-sided-section'>
                    <p>
                        <i className={'wi wi-rain'}></i>
                    </p>
                    <p className='extra-info-leftside'>
                        {pressure} <br/>
                        Pressure
                    </p>
                </div>
                <div className='two-sided-section'>
                    <p>
                        <i className={'wi wi-strong-wind'}></i>
                    </p>
                    <p className='extra-info-leftside'>
                        {speed} Km/h <br/>
                        speed
                    </p>
                </div>
            </div>
        </div>
    </article>

    </>
  )
}

export default WeatherCard